import { msAPI, manageAPI } from "./index";

/**
 * Get product image overrides for multiple SKUs
 * @param {string[]} skus - Array of SKU IDs
 * @returns {Promise<{image_overrides: Array}>}
 */

/**
 * Upload or replace a product image override
 * If an image already exists, it will be replaced
 * @param {string} sku_id - The SKU ID
 * @param {Object} imageData - Image metadata
 * @param {string} imageData.url - URL of the uploaded image
 * @param {string} imageData.key - S3 key
 * @param {string} imageData.bucket - S3 bucket name
 * @returns {Promise<{image: Object}>}
 */
export async function createProductImage(sku_id, imageData) {
  return (await msAPI.put(`merchant/product-image-override`, {
    sku_id: sku_id,
    bucket: imageData.bucket,
    key: imageData.key,
    image_url: imageData.url
  })).data;
}

/**
 * Delete a product image override
 * Uses the same PUT route with empty values to clear the override
 * @param {string} sku_id - The SKU ID
 * @returns {Promise<{success: boolean}>}
 */
export async function deleteProductImage(sku_id) {
  return (await msAPI.put(`merchant/product-image-override`, {
    sku_id: sku_id,
    bucket: "",
    key: "",
    image_url: ""
  })).data;
}

